import axios from "axios";
import { API_BASE_URL } from "../constants/ApiConfig";
import { getLanguage } from "../utils/helperFunctions/languageStorage";
import { getToken, removeToken } from "../utils/helperFunctions/tokenStorage";

let unauthorizedHandler: (() => void) | null = null;

let subscriptionExpiredHandler: (() => void) | null = null;

export const setUnauthorizedHandler = (handler: (() => void) | null) => {
  unauthorizedHandler = handler;
};

export const setSubscriptionExpiredHandler = (handler: (() => void) | null) => {
  subscriptionExpiredHandler = handler;
};

const apiClient = axios.create({
  baseURL: API_BASE_URL,
  timeout: 15000,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
  },
});

apiClient.interceptors.request.use(async (config) => {
  const token = await getToken();

  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  config.headers["Accept-Language"] = (await getLanguage()) || "bs";

  return config;
});

apiClient.interceptors.response.use(
  (response) => response,

  async (error) => {
    if (
      error?.response?.status === 402 &&
      error?.response?.data?.code === "subscription_expired" &&
      subscriptionExpiredHandler
    ) {
      subscriptionExpiredHandler();
    }

    if (error?.response?.status === 401) {
      await removeToken();

      if (unauthorizedHandler) {
        unauthorizedHandler();
      } else {
        window.location.href = "/login";
      }
    }

    return Promise.reject(error);
  },
);

export default apiClient;
